import type { TOC } from '@ember/component/template-only'
import { ChartsDrivingTestsTotals } from 'district-ui-client/components/charts/driving-tests/totals/component'
import { DetailedPageWrapper } from 'district-ui-client/components/reporting/detailed-page-wrapper'
import type MsDrivingTestsRoute from 'district-ui-client/reporting/ui-scope/maths/driving-tests/route'
import { not } from 'ember-truth-helpers'
import fullGradeName from 'district-ui-client/helpers/full-grade-name'
import { t } from 'ember-intl'
import RouteTemplate from 'ember-route-template'

interface Signature {
  Args: {
    model: ModelFor<MsDrivingTestsRoute>
  }
}

export const MsDrivingTestsRouteTemplate: TOC<Signature> = <template>
  <DetailedPageWrapper @empty={{not @model.drivingTestsTotals}}>
    {{#each @model.drivingTestsTotals as |gradeData|}}
      <div class="detailed-chart-wrapper">
        <ChartsDrivingTestsTotals
          class="h-full"
          @data={{gradeData}}
          @product={{@model.product}}
          @grade={{fullGradeName gradeData.grade_position}}
          @tooltip={{t "reporting.tooltips.drivingTestsTotals.maths"}}
          @title={{t "reporting.chartTitles.drivingTestsTotals"}}
        />
      </div>
    {{/each}}
  </DetailedPageWrapper>
</template>

export default RouteTemplate(MsDrivingTestsRouteTemplate)
